<template>
  <b-row class="base-row-padded">
    <b-col>
      <b-row>
        <b-col cols="4">
          <b-button variant="light" :to="{name: 'groups'}"> &lt; Back to Groups</b-button>
        </b-col>
        <b-col cols="8" class="d-flex justify-content-end">
          <b-button :disabled="formLoading" class="ml-2" variant="success" @click="handleSubmit">Save</b-button>
          <b-button :disabled="formLoading" class="ml-2" v-if="id !== 'new'" variant="danger" @click="deleteGroupProxy">Delete</b-button>
        </b-col>
        <b-col cols="12" class="my-2">
          <h2>Group</h2>
        </b-col>
      </b-row>

      <b-form @submit.prevent="handleSubmit" v-if="group">

        <b-form-group>
          <b-card header="Group Information">
            <b-form-group label="Name:">
              <b-form-input v-model="group.name" required placeholder="Name"/>
              <b-form-invalid-feedback
                v-if="formErrors && formErrors.name && formErrors.name.length > 0" :state="false">
                <p v-for="(e, $index) in formErrors.name" :key="$index">{{e}}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Tag:" v-if="tags && id === 'new'">
              <b-form-select v-model="group.tag_id">
                <option :value="null">--None--</option>
                <option v-for="(tag, $index) in tags" :value="tag.value" :key="$index">{{tag.text}}</option>
              </b-form-select>
              <b-form-invalid-feedback
                v-if="formErrors && formErrors.tag_id && formErrors.tag_id.length > 0" :state="false">
                <p v-for="(e, $index) in formErrors.tag_id" :key="$index">{{e}}</p>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-card>
        </b-form-group>


        <ObjectSettings v-if="id !== 'new'" :settingsObj="group.settings" />

        <b-form-group v-if="id !== 'new'">
          <b-card header-tag="header">
            <div slot="header" class="d-flex align-items-center justify-content-between">
              Group Devices
              <b-button class="float-right" @click="addDevice" size="sm" variant="success">
                <fa-icon icon="plus"/>
              </b-button>
            </div>
            <b-table v-if="group.devices && group.devices.length"
              class="table-sm"
              :items="group.devices"
              :fields="deviceFields"
              :per-page="perPage"
              :current-page="currentPage">
              <template slot="actions" slot-scope="data">
                <b-button @click="removeDevice(data.item)" size="sm" variant="danger">
                  <fa-icon icon="trash"/>
                </b-button>
              </template>
            </b-table>
            <b-pagination
              align="end"
              v-model="currentPage"
              :per-page="perPage"
              :limit="paginationLimit"
              :total-rows="totalItems"
              first-number
              last-number>
            </b-pagination>
          </b-card>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import formsMixin from '@/mixins/forms';
import settingsMixin from '@/mixins/settings';
import groupsMixin from './groupsMixin';
import ObjectSettings from '@/views/admin/shared/ObjectSettings.vue';
import { DeviceAttrService } from '@/services/deviceAttrService';

export default {
  mixins: [formsMixin, settingsMixin, groupsMixin],
  components: { ObjectSettings },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      paginationLimit: 10,
      group: null,
      tags: null,
      deviceFields: [
        'name',
        'address',
        'activation_code',
        {
          key: 'actions',
          label: '',
        },
      ],
    };
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    groupObj: {
      type: [Object],
      required: false,
    },
  },
  async created() {
    const res = await DeviceAttrService.getAllAttrs();
    this.tags = res.tags;
    if (this.id !== 'new') {
      this.getGroupProxy();
    } else {
      this.group = {
        name: '',
        settings: this.generateEmptySettings(),
        devices: [],
        tag_id: null,
      };
    }
  },
  methods: {
    getGroupProxy() {
      if (!this.groupObj) {
        this.getGroup({ id: this.id })
          .then((data) => {
            this.parseGroup(data);
          })
          .catch(() => {});
      } else {
        this.parseGroup(this.groupObj);
      }
    },
    handleSubmit() {
      const groupObject = { ...this.group };
      groupObject.settings = { ...this.group.settings };
      delete groupObject.settings.business_hours;
      groupObject.settings.business_hours = this.flattenBusinessHours(this.group.settings);
      delete groupObject.devices;
      groupObject.devices = this.group.devices.map(e => e.id);

      if (this.id === 'new') {
        this.createGroup(groupObject)
          .then(() => {})
          .catch(() => {});
      } else {
        this.updateGroup(groupObject).then((updatedGroup) => {
          this.parseGroup(updatedGroup);
        }).catch(() => {});
      }
    },
    deleteGroupProxy() {
      this.deleteGroup(this.group).then(() => {
        this.$router.push({ name: 'groups' });
      })
        .catch(() => {});
    },
    async parseGroup(newGroup) {
      this.group = newGroup;
      this.group.settings.business_hours = this.extendBusinessHours(this.group.settings);
      const res = await DeviceAttrService.getAllAttrs();
      this.tags = res.tags;
    },
    removeDevice(dvc) {
      this.group.devices = this.group.devices.filter(e => e !== dvc);
    },
    addDevice() {
      this.$root.$emit('modal-show', {
        title: 'Choose devices',
        body: '',
        cbConfirm: (devices) => {
          this.group.devices = [...this.group.devices, ...devices];
        },
        confirmText: 'OK',
        cancelText: 'Cancel',
        devicePicker: true,
        devicesFilterArray: this.group.devices,
      });
    },
  },
  computed: {
    totalItems() {
      return this.group.devices.length;
    },
  },
};
</script>
